// import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
// import { List, Box, Tooltip, IconButton, Typography } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { useGetAnnouncementsQuery } from '../announcementApiSlice';
// import { selectCurrentUser, setAnnouncementStatus } from '../../Auth/authSlice';
// import AnnouncementItem from './AnnouncementItem';
// import { groupAnnouncementsByDate } from '../utility/utilities';
// import StyledDateDivider from './StyledDateDivider';
// import PinnedAnnouncement from './PinnedAnnouncement';
// import { Element } from 'react-scroll';
// import { KeyboardArrowDown } from '@mui/icons-material';
// import { SkeletonAnnouncementList } from '../skeletons/SkeletonAnnouncementList';
// import { useAbility } from '@casl/react';
// import { AbilityContext } from '../../../context/Ability';
// import useDetectKeyboardOpen from 'use-detect-keyboard-open';
// import { empty } from '../../Gift/assets/index';

// const AnnouncementList = ({ setEditingAnnouncement, showScrollButton, setShowScrollButton, inputHeight }) => {
//   const user = useSelector(selectCurrentUser);
//   const { data: announcementData, isLoading,isFetching, error,refetch } = useGetAnnouncementsQuery(undefined,{refetchOnMountOrArgChange:true});
//   const listRef = useRef(null);
//   const dispatch = useDispatch();
//   const ability = useAbility(AbilityContext);
//   const isKeyboardOpen = useDetectKeyboardOpen();
  
//   // Set announcement status on mount
//   useLayoutEffect(() => {
//     dispatch(setAnnouncementStatus(false));
//   }, [dispatch]);

//   // Always show the last item without animation
//   useLayoutEffect(() => {
//     if (listRef.current) {
//       // Set scroll position directly without animation
//       listRef.current.scrollTop = listRef.current.scrollHeight;
//     }
//   }); // Runs after every render
  
//   // Handle scroll events to show/hide scroll button
//   const handleScroll = () => {
//     if (!listRef.current) return;
    
//     const { scrollTop, scrollHeight, clientHeight } = listRef.current;
//     const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
//     setShowScrollButton(!isAtBottom);
//   };
  
//   // Scroll to bottom function (for manual scroll button)
//   const scrollToBottom = () => {
//     if (listRef.current) {
//       listRef.current.scrollTo({
//         top: listRef.current.scrollHeight,
//         behavior: 'smooth',
//       });
//     }
//   };
  
//   // Group and process announcements
//   const groupedAnnouncements = groupAnnouncementsByDate(announcementData);
//   const pinnedAnnouncement = announcementData?.find((ann) => ann.isPinned) || null;
//   const hasAnnouncement = Object.keys(groupedAnnouncements).length > 0;
//   if (isLoading || isFetching) return <SkeletonAnnouncementList />;
//   if (error || !hasAnnouncement)
//     return (
//       <Box
//         sx={{
//           // backgroundColor: 'black',
//           border: 'none',
//           borderRadius: 0,
//           width: '100%',
//           height: '90%',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           // position: 'absolute',
//           // zIndex: '100000',
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             width: '100%',
//             alignItems: 'center',
//             // marginTop: '10rem',
//           }}
//         >
//           <img style={{ width: '50%' }} src={empty} alt="pending" />
//           <Typography sx={{ fontSize: '1rem', p: 2, color: 'lightgrey' }}>No Pings Yet</Typography>
//         </Box>
//       </Box>
//     );

//   return (
//     // <>
//     //   {hasAnnouncement ? (
//         <Box sx={{ width: '100%', boxShadow: 'none', height: '100%',overflow:'scroll' }}>
//           <PinnedAnnouncement
//             pinnedAnnouncement={pinnedAnnouncement}
//             user={user}
//             setEditingAnnouncement={setEditingAnnouncement}
//           />

//           <List
//             id="announcement-list-container"
//             ref={listRef}
//             sx={{
//               overflow: 'scroll',
//               padding: 0,
//               border: 0,
//               height: ability.can('create', 'Announcement')
//                 ? pinnedAnnouncement
//                   ? isKeyboardOpen
//                     ? `calc(90%)`
//                     : `calc(100%)`
//                   : isKeyboardOpen
//                   ? `calc(100%)`
//                   : `calc(100%)`
//                 : pinnedAnnouncement
//                 ? `calc(73vh)`
//                 : `calc(100%)`,
//             }}
//             onScroll={handleScroll}
//           >
//             {Object.entries(groupedAnnouncements).map(([date, announcements]) => (
//               <React.Fragment key={date}>
//                 <StyledDateDivider date={date} />
//                 {announcements.map((announcement) => (
//                   <Element key={`announcement-${announcement._id}`} name={`announcement-${announcement._id}`}>
//                     <AnnouncementItem
//                       announcement={announcement}
//                       user={user}
//                       setEditingAnnouncement={setEditingAnnouncement}
//                     />
//                   </Element>
//                 ))}
//               </React.Fragment>
//             ))}
//           </List>
//           {showScrollButton ? (
//             <Tooltip title="Scroll to bottom" placement="left">
//               <IconButton
//                 onClick={scrollToBottom}
//                 sx={{
//                   position: 'absolute',
//                   bottom: 80,
//                   right: 10,
//                   backgroundColor: 'lightgray',
//                   boxShadow: 1,
//                   '&:hover': {
//                     backgroundColor: 'grey.300',
//                   },
//                   zIndex: 1000,
//                   color: 'black',
//                 }}
//               >
//                 <KeyboardArrowDown sx={{ m: '-5px' }} />
//               </IconButton>
//             </Tooltip>
//           ) : null}
//         </Box>
//     //   ) : (
//     //     <Box
//     //       sx={{
//     //         // backgroundColor: 'black',
//     //         border: 'none',
//     //         borderRadius: 0,
//     //         width: '100%',
//     //         height: '100%',
//     //         display: 'flex',
//     //         justifyContent: 'center',
//     //         alignItems: 'center',
//     //         // position: 'absolute',
//     //         // zIndex: '100000',
//     //       }}
//     //     >
//     //       <Box
//     //         sx={{
//     //           display: 'flex',
//     //           flexDirection: 'column',
//     //           justifyContent: 'center',
//     //           width: '100%',
//     //           alignItems: 'center',
//     //           // marginTop: '10rem',
//     //         }}
//     //       >
//     //         <img style={{ width: '50%' }} src={empty} alt="pending" />
//     //         <Typography sx={{ fontSize: '1rem', p: 2, color: 'lightgrey' }}>No Announcements Yet</Typography>
//     //       </Box>
//     //     </Box>
//     //   )}
//     // </>
//   );
// };

// export default AnnouncementList;

//2nd approch
// import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from 'react';
// import { List, Box, Tooltip, IconButton, Typography } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { useGetAnnouncementsQuery } from '../announcementApiSlice';
// import { selectCurrentUser, setAnnouncementStatus } from '../../Auth/authSlice';
// import AnnouncementItem from './AnnouncementItem';
// import { groupAnnouncementsByDate } from '../utility/utilities';
// import StyledDateDivider from './StyledDateDivider';
// import PinnedAnnouncement from './PinnedAnnouncement';
// import { Element } from 'react-scroll';
// import { KeyboardArrowDown } from '@mui/icons-material';
// import { SkeletonAnnouncementList } from '../skeletons/SkeletonAnnouncementList';
// import { useAbility } from '@casl/react';
// import { AbilityContext } from '../../../context/Ability';
// import useDetectKeyboardOpen from 'use-detect-keyboard-open';
// import { empty } from '../../Gift/assets/index';

// const AnnouncementList = ({ setEditingAnnouncement, showScrollButton, setShowScrollButton, inputHeight }) => {
//   const user = useSelector(selectCurrentUser);
//   const { data: announcementData, isLoading, isFetching, error, refetch } = useGetAnnouncementsQuery(undefined, { refetchOnMountOrArgChange: true });
//   const listRef = useRef(null);
//   const dispatch = useDispatch();
//   const ability = useAbility(AbilityContext);
//   const isKeyboardOpen = useDetectKeyboardOpen();
  
//   // Simple state management for scroll behavior
//   const [scrollState, setScrollState] = useState({
//     shouldScrollToBottom: true,  // Always true when component mounts (coming from another page)
//     isNavigatingToPinned: false // True when user clicks pinned announcement
//   });
  
//   // Set announcement status on mount
//   useLayoutEffect(() => {
//     dispatch(setAnnouncementStatus(false));
//   }, [dispatch]);

//   // Reset scroll state when component mounts (coming from another page)
//   useEffect(() => {
//     console.log('Component mounted - setting shouldScrollToBottom to true'); // Debug log
//     setScrollState({
//       shouldScrollToBottom: true,  // ALWAYS scroll to bottom when coming from another page
//       isNavigatingToPinned: false
//     });
//   }, []); // Only runs on mount

//   // Handle auto-scroll to bottom - THE CORE LOGIC
//   useLayoutEffect(() => {
//     if (!listRef.current || !announcementData || isLoading || isFetching) return;
    
//     // SCROLL TO BOTTOM if:
//     // 1. We should scroll to bottom AND
//     // 2. We're NOT navigating to pinned announcement
//     if (scrollState.shouldScrollToBottom && !scrollState.isNavigatingToPinned) {
//       // Use setTimeout to ensure DOM is fully rendered
//       setTimeout(() => {
//         if (listRef.current) {
//           listRef.current.scrollTop = listRef.current.scrollHeight;
//           console.log('Scrolled to bottom:', listRef.current.scrollHeight); // Debug log
//           // After scrolling once, turn off auto-scroll until component remounts
//           setScrollState(prev => ({ ...prev, shouldScrollToBottom: false }));
//         }
//       }, 100);
//     }
//   }, [announcementData, scrollState.shouldScrollToBottom, scrollState.isNavigatingToPinned, isLoading, isFetching]);

//   // Additional effect to ensure scroll after data loads completely
//   useEffect(() => {
//     if (!isLoading && !isFetching && announcementData && scrollState.shouldScrollToBottom && !scrollState.isNavigatingToPinned) {
//       // Double-check scroll after all loading is complete
//       setTimeout(() => {
//         if (listRef.current) {
//           listRef.current.scrollTop = listRef.current.scrollHeight;
//           console.log('Force scroll to bottom after load:', listRef.current.scrollHeight); // Debug log
//         }
//       }, 200);
//     }
//   }, [isLoading, isFetching, announcementData, scrollState.shouldScrollToBottom, scrollState.isNavigatingToPinned]);
  
//   // Handle scroll events to show/hide scroll button
//   const handleScroll = useCallback(() => {
//     if (!listRef.current) return;
    
//     const { scrollTop, scrollHeight, clientHeight } = listRef.current;
//     const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
    
//     setShowScrollButton(!isAtBottom);
    
//     // If user manually scrolls to bottom, reset pinned navigation state
//     if (isAtBottom && scrollState.isNavigatingToPinned) {
//       setScrollState(prev => ({ 
//         ...prev, 
//         isNavigatingToPinned: false,
//         shouldScrollToBottom: true // Re-enable for new announcements
//       }));
//     }
//   }, [setShowScrollButton, scrollState.isNavigatingToPinned]);
  
//   // Scroll to bottom function (for manual scroll button)
//   const scrollToBottom = useCallback(() => {
//     if (listRef.current) {
//       listRef.current.scrollTo({
//         top: listRef.current.scrollHeight,
//         behavior: 'smooth',
//       });
//       // Reset navigation state and enable auto-scroll for new content
//       setScrollState(prev => ({
//         ...prev,
//         isNavigatingToPinned: false,
//         shouldScrollToBottom: true
//       }));
//     }
//   }, []);
  
//   // Handle pinned announcement click - PREVENT AUTO-SCROLL
//   const handlePinnedAnnouncementClick = useCallback((announcementId) => {
//     // FIRST: Set state to prevent auto-scroll
//     setScrollState(prev => ({
//       ...prev,
//       isNavigatingToPinned: true,
//       shouldScrollToBottom: false
//     }));
    
//     // THEN: Navigate to the pinned announcement  
//     setTimeout(() => {
//       const element = document.querySelector(`[name="announcement-${announcementId}"]`);
//       if (element && listRef.current) {
//         const elementTop = element.offsetTop;
//         const listTop = listRef.current.offsetTop;
//         const scrollPosition = elementTop - listTop - 20;
        
//         listRef.current.scrollTo({
//           top: Math.max(0, scrollPosition),
//           behavior: 'smooth',
//         });
//       }
//     }, 100); // Small delay to ensure state is updated
//   }, []);
  
//   // Handle new announcements - scroll to bottom for new content
//   const previousAnnouncementCount = useRef(0);
//   useEffect(() => {
//     if (!announcementData) return;
    
//     const currentCount = announcementData.length;
//     const hasNewAnnouncements = currentCount > previousAnnouncementCount.current && previousAnnouncementCount.current > 0;
    
//     // If new announcements arrive and user is not viewing pinned, scroll to bottom
//     if (hasNewAnnouncements && !scrollState.isNavigatingToPinned) {
//       setScrollState(prev => ({
//         ...prev,
//         shouldScrollToBottom: true
//       }));
//     }
    
//     previousAnnouncementCount.current = currentCount;
//   }, [announcementData, scrollState.isNavigatingToPinned]);
  
//   // Group and process announcements
//   const groupedAnnouncements = groupAnnouncementsByDate(announcementData);
//   const pinnedAnnouncement = announcementData?.find((ann) => ann.isPinned) || null;
//   const hasAnnouncement = Object.keys(groupedAnnouncements).length > 0;
  
//   if (isLoading || isFetching) return <SkeletonAnnouncementList />;
  
//   if (error || !hasAnnouncement)
//     return (
//       <Box
//         sx={{
//           border: 'none',
//           borderRadius: 0,
//           width: '100%',
//           height: '90%',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             width: '100%',
//             alignItems: 'center',
//           }}
//         >
//           <img style={{ width: '50%' }} src={empty} alt="pending" />
//           <Typography sx={{ fontSize: '1rem', p: 2, color: 'lightgrey' }}>No Pings Yet</Typography>
//         </Box>
//       </Box>
//     );

//   return (
//     <Box sx={{ width: '100%', boxShadow: 'none', height: '100%', overflow: 'scroll' }}>
//       <PinnedAnnouncement
//         pinnedAnnouncement={pinnedAnnouncement}
//         user={user}
//         setEditingAnnouncement={setEditingAnnouncement}
//         onPinnedClick={handlePinnedAnnouncementClick}
//       />

//       <List
//         id="announcement-list-container"
//         ref={listRef}
//         sx={{
//           overflow: 'scroll',
//           padding: 0,
//           border: 0,
//           height: ability.can('create', 'Announcement')
//             ? pinnedAnnouncement
//               ? isKeyboardOpen
//                 ? `calc(90%)`
//                 : `calc(100%)`
//               : isKeyboardOpen
//               ? `calc(100%)`
//               : `calc(100%)`
//             : pinnedAnnouncement
//             ? `calc(73vh)`
//             : `calc(100%)`,
//         }}
//         onScroll={handleScroll}
//       >
//         {Object.entries(groupedAnnouncements).map(([date, announcements]) => (
//           <React.Fragment key={date}>
//             <StyledDateDivider date={date} />
//             {announcements.map((announcement) => (
//               <Element key={`announcement-${announcement._id}`} name={`announcement-${announcement._id}`}>
//                 <AnnouncementItem
//                   announcement={announcement}
//                   user={user}
//                   setEditingAnnouncement={setEditingAnnouncement}
//                 />
//               </Element>
//             ))}
//           </React.Fragment>
//         ))}
//       </List>
      
//       {showScrollButton ? (
//         <Tooltip title="Scroll to bottom" placement="left">
//           <IconButton
//             onClick={scrollToBottom}
//             sx={{
//               position: 'absolute',
//               bottom: 80,
//               right: 10,
//               backgroundColor: 'lightgray',
//               boxShadow: 1,
//               '&:hover': {
//                 backgroundColor: 'grey.300',
//               },
//               zIndex: 1000,
//               color: 'black',
//             }}
//           >
//             <KeyboardArrowDown sx={{ m: '-5px' }} />
//           </IconButton>
//         </Tooltip>
//       ) : null}
//     </Box>
//   );
// };

// export default AnnouncementList;

//3rd approch
import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from 'react';
import { List, Box, Tooltip, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useGetAnnouncementsQuery } from '../announcementApiSlice';
import { selectCurrentUser, setAnnouncementStatus } from '../../Auth/authSlice';
import AnnouncementItem from './AnnouncementItem';
import { groupAnnouncementsByDate } from '../utility/utilities';
import StyledDateDivider from './StyledDateDivider';
import PinnedAnnouncement from './PinnedAnnouncement';
import { Element } from 'react-scroll';
import { KeyboardArrowDown } from '@mui/icons-material';
import { SkeletonAnnouncementList } from '../skeletons/SkeletonAnnouncementList';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../context/Ability';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';
import { empty } from '../../Gift/assets/index';

const AnnouncementList = ({ setEditingAnnouncement, showScrollButton, setShowScrollButton, inputHeight }) => {
  const user = useSelector(selectCurrentUser);
  const { data: announcementData, isLoading, isFetching, error, refetch } = useGetAnnouncementsQuery(undefined, { refetchOnMountOrArgChange: true });
  const listRef = useRef(null);
  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);
  const isKeyboardOpen = useDetectKeyboardOpen();
  
  // Simple state management for scroll behavior
  const [scrollState, setScrollState] = useState({
    shouldScrollToBottom: true,  // Always true when component mounts (coming from another page)
    isNavigatingToPinned: false // True when user clicks pinned announcement
  });
  
  // Set announcement status on mount
  useLayoutEffect(() => {
    dispatch(setAnnouncementStatus(false));
  }, [dispatch]);

  // Reset scroll state when component mounts (coming from another page)
  useEffect(() => {
    console.log('Component mounted - setting shouldScrollToBottom to true'); // Debug log
    setScrollState({
      shouldScrollToBottom: true,  // ALWAYS scroll to bottom when coming from another page
      isNavigatingToPinned: false
    });
  }, []); // Only runs on mount

  // Handle auto-scroll to bottom - THE CORE LOGIC
  useLayoutEffect(() => {
    if (!listRef.current || !announcementData || isLoading || isFetching) return;
    
    // SCROLL TO BOTTOM if:
    // 1. We should scroll to bottom AND
    // 2. We're NOT navigating to pinned announcement
    if (scrollState.shouldScrollToBottom && !scrollState.isNavigatingToPinned) {
      // Use setTimeout to ensure DOM is fully rendered
      setTimeout(() => {
        if (listRef.current) {
          listRef.current.scrollTop = listRef.current.scrollHeight;
          console.log('Scrolled to bottom:', listRef.current.scrollHeight); // Debug log
          // After scrolling once, turn off auto-scroll until component remounts
          setScrollState(prev => ({ ...prev, shouldScrollToBottom: false }));
        }
      }, 100);
    }
  }, [announcementData, scrollState.shouldScrollToBottom, scrollState.isNavigatingToPinned, isLoading, isFetching]);

  // Additional effect to ensure scroll after data loads completely
  useEffect(() => {
    if (!isLoading && !isFetching && announcementData && scrollState.shouldScrollToBottom && !scrollState.isNavigatingToPinned) {
      // Double-check scroll after all loading is complete
      setTimeout(() => {
        if (listRef.current) {
          listRef.current.scrollTop = listRef.current.scrollHeight;
          console.log('Force scroll to bottom after load:', listRef.current.scrollHeight); // Debug log
        }
      }, 200);
    }
  }, [isLoading, isFetching, announcementData, scrollState.shouldScrollToBottom, scrollState.isNavigatingToPinned]);
  
  // Handle scroll events to show/hide scroll button
  const handleScroll = useCallback(() => {
    if (!listRef.current) return;
    
    const { scrollTop, scrollHeight, clientHeight } = listRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
    
    setShowScrollButton(!isAtBottom);
    
    // If user manually scrolls to bottom, reset pinned navigation state
    if (isAtBottom && scrollState.isNavigatingToPinned) {
      setScrollState(prev => ({ 
        ...prev, 
        isNavigatingToPinned: false,
        shouldScrollToBottom: true // Re-enable for new announcements
      }));
    }
  }, [setShowScrollButton, scrollState.isNavigatingToPinned]);
  
  // Scroll to bottom function (for manual scroll button)
  const scrollToBottom = useCallback(() => {
    if (listRef.current) {
      listRef.current.scrollTo({
        top: listRef.current.scrollHeight,
        behavior: 'smooth',
      });
      // Reset navigation state and enable auto-scroll for new content
      setScrollState(prev => ({
        ...prev,
        isNavigatingToPinned: false,
        shouldScrollToBottom: true
      }));
    }
  }, []);
  
  // Handle pinned announcement click - PREVENT AUTO-SCROLL
  const handlePinnedAnnouncementClick = useCallback((announcementId) => {
    // FIRST: Set state to prevent auto-scroll
    setScrollState(prev => ({
      ...prev,
      isNavigatingToPinned: true,
      shouldScrollToBottom: false
    }));
    
    // THEN: Navigate to the pinned announcement  
    setTimeout(() => {
      const element = document.querySelector(`[name="announcement-${announcementId}"]`);
      if (element && listRef.current) {
        const elementTop = element.offsetTop;
        const listTop = listRef.current.offsetTop;
        const scrollPosition = elementTop - listTop - 20;
        
        listRef.current.scrollTo({
          top: Math.max(0, scrollPosition),
          behavior: 'smooth',
        });
      }
    }, 100); // Small delay to ensure state is updated
  }, []);
  
  // Handle new announcements - scroll to bottom for new content
  const previousAnnouncementCount = useRef(0);
  useEffect(() => {
    if (!announcementData) return;
    
    const currentCount = announcementData.length;
    const hasNewAnnouncements = currentCount > previousAnnouncementCount.current && previousAnnouncementCount.current > 0;
    
    // If new announcements arrive and user is not viewing pinned, scroll to bottom
    if (hasNewAnnouncements && !scrollState.isNavigatingToPinned) {
      setScrollState(prev => ({
        ...prev,
        shouldScrollToBottom: true
      }));
    }
    
    previousAnnouncementCount.current = currentCount;
  }, [announcementData, scrollState.isNavigatingToPinned]);
  
  // Group and process announcements
  const groupedAnnouncements = groupAnnouncementsByDate(announcementData);
  const pinnedAnnouncement = announcementData?.find((ann) => ann.isPinned) || null;
  const hasAnnouncement = Object.keys(groupedAnnouncements).length > 0;
  
  if (isLoading || isFetching) return <SkeletonAnnouncementList />;
  
  if (error || !hasAnnouncement)
    return (
      <Box
        sx={{
          border: 'none',
          borderRadius: 0,
          width: '100%',
          height: '90%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <img style={{ width: '50%' }} src={empty} alt="pending" />
          <Typography sx={{ fontSize: '1rem', p: 2, color: 'lightgrey' }}>No Pings Yet</Typography>
        </Box>
      </Box>
    );

  return (
    <Box sx={{ width: '100%', boxShadow: 'none', height: '100%', overflow: 'scroll' }}>
      <PinnedAnnouncement
        pinnedAnnouncement={pinnedAnnouncement}
        user={user}
        setEditingAnnouncement={setEditingAnnouncement}
        onPinnedClick={handlePinnedAnnouncementClick}
      />

      <List
        id="announcement-list-container"
        ref={listRef}
        sx={{
          overflow: 'scroll',
          padding: 0,
          paddingBottom: 0, // Add padding to prevent last item cutoff
          border: 0,
          height: ability.can('create', 'Announcement')
            ? pinnedAnnouncement
              ? `calc(100% - 60px)` // Fixed height with buffer for pinned + input
              : `calc(100% - 10px)`  // Fixed height with buffer for input only
            : pinnedAnnouncement
            ? `calc(100% - 60px)`   // Fixed height with buffer for pinned only
            : `calc(100%)`,  // Fixed height with small buffer
        }}
        onScroll={handleScroll}
      >
        {Object.entries(groupedAnnouncements).map(([date, announcements]) => (
          <React.Fragment key={date}>
            <StyledDateDivider date={date} />
            {announcements.map((announcement) => (
              <Element key={`announcement-${announcement._id}`} name={`announcement-${announcement._id}`}>
                <AnnouncementItem
                  announcement={announcement}
                  user={user}
                  setEditingAnnouncement={setEditingAnnouncement}
                />
              </Element>
            ))}
          </React.Fragment>
        ))}
      </List>
      
      {showScrollButton ? (
        <Tooltip title="Scroll to bottom" placement="left">
          <IconButton
            onClick={scrollToBottom}
            sx={{
              position: 'absolute',
              bottom: 80,
              right: 10,
              backgroundColor: 'lightgray',
              boxShadow: 1,
              '&:hover': {
                backgroundColor: 'grey.300',
              },
              zIndex: 1000,
              color: 'black',
            }}
          >
            <KeyboardArrowDown sx={{ m: '-5px' }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
  );
};

export default AnnouncementList;